<template>
  <div class="flight-card bg-white py-1 px-0.5 rounded-md border border-grayNeutralLight w-[260px] flex-shrink-0">
    <!-- header -->
    <div class="w-full flex justify-between items-center mb-1">
      <slot name="header"></slot>
    </div>
    <slot></slot>
    <!-- end -->
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: Number,
      required: 0,
    },
  },
  data() {
    return {
      is_loading: false,
    }
  },
}
</script>
